import axios from 'axios'
import request, { getBaseUrl } from '@/utils/request'
import { getToken } from '@/utils/auth'

const DIAGNOSTIC_REPORTS_URL = '/api/v1/admin/diagnostics/reports'

function unwrap(response) {
  // request.js already unwraps the normal {code,msg,data} success envelope.
  // Keep compatibility with raw Axios responses and direct JSON responses so
  // this API module does not accidentally return an AxiosResponse to the page.
  const body = response && response.status !== undefined && response.data !== undefined
    ? response.data
    : response
  return body && body.code !== undefined && body.data !== undefined ? body.data : body
}

export function listDiagnosticReports(params) {
  return request({
    url: DIAGNOSTIC_REPORTS_URL,
    method: 'get',
    params
  }).then(unwrap)
}

export function getDiagnosticReport(reportId) {
  return request({
    url: `${DIAGNOSTIC_REPORTS_URL}/${encodeURIComponent(reportId)}`,
    method: 'get'
  }).then(unwrap)
}

export function updateDiagnosticReport(reportId, data) {
  return request({
    url: `${DIAGNOSTIC_REPORTS_URL}/${encodeURIComponent(reportId)}`,
    method: 'patch',
    data
  }).then(unwrap)
}

export async function downloadDiagnosticBundle(reportId, reason) {
  const response = await axios({
    url: `${getBaseUrl()}${DIAGNOSTIC_REPORTS_URL}/${encodeURIComponent(reportId)}/bundle/download`,
    method: 'post',
    data: { reason },
    responseType: 'blob',
    timeout: 1000000,
    headers: { Authorization: getToken() }
  })
  const contentType = String(response.headers && response.headers['content-type'] || response.data && response.data.type || '').toLowerCase()
  const disposition = String(response.headers && response.headers['content-disposition'] || '').toLowerCase()
  const isArchive = contentType.includes('application/zip') ||
    contentType.includes('application/octet-stream') || disposition.includes('attachment')
  if (isArchive) return response

  let message = '下载诊断包失败'
  try {
    const text = response.data instanceof Blob ? await response.data.text() : String(response.data || '')
    const payload = JSON.parse(text)
    message = payload.msg || payload.message || payload.detail || message
  } catch (error) {
    // Keep the generic message for an HTML/proxy response.
  }
  throw new Error(message)
}
